import React, { useState } from 'react';
import { Divider, LoadingSpinner, Stack, Text } from '@adc/parallax-component-library';
import { useApiError, useLibrePartner, useToast } from 'Hooks';
import { Link } from 'Components/utility';
import { formatDate } from 'Utilities/dateHelpers';
import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';
const Redox = ({ partnerConnection }) => {
    const [footerLoading, setFooterLoading] = useState(false);
    const { showApiErrorModal } = useApiError();
    const { showToast } = useToast();
    const { removePartner, showStopSharingModal } = useLibrePartner();
    const onStopSharing = () => {
        showStopSharingModal(partnerConnection.partner.name, 'ConnectedRedoxPartner.modals.stopSharingRedoxPartner.title', 'ConnectedRedoxPartner.modals.stopSharingRedoxPartner.body', async () => {
            try {
                setFooterLoading(true);
                await removePartner(partnerConnection.partner.id);
                showToast({
                    message: i18n.t('Global.modals.removeConnection.connectionRemoved'),
                    'aria-label': i18n.t('Global.modals.removeConnection.connectionRemoved'),
                });
                mediator.publish('router:navigate', '/connections');
            }
            catch {
                showApiErrorModal();
            }
            finally {
                setFooterLoading(false);
            }
        });
    };
    return (React.createElement(Stack, { margin: "$4", padding: "$4", backgroundColor: "$surface.container", border: "$1.5", shadow: "$1" },
        React.createElement(Text, { testID: "PartnerConnection.title", color: "$text.100", fontWeight: "$h4.strong", fontSize: "$h4.strong" }, i18n.t('ConnectedRedoxPartner.content.connectedRedoxPartnerTile.primaryText')),
        React.createElement(Text, { testID: "PartnerConnection.bodyText", marginTop: "$2", color: "$text.100", fontWeight: "$bodyBase.default", fontSize: "$bodyBase.default" }, i18n.t('ConnectedRedoxPartner.content.connectedRedoxPartnerTile.secondaryText', {
            partnerName: partnerConnection.partner.name,
        })),
        React.createElement(Text, { testID: "PartnerConnection.connectedAt", marginTop: "$4", color: "$text.60", fontWeight: "$bodySmall.default", fontSize: "$bodySmall.default" }, `${i18n.t('ConnectedRedoxPartner.content.connectedRedoxPartnerTile.bodyText')} ${formatDate(partnerConnection.consent.created)}`),
        React.createElement(Divider, { marginVertical: "$4", borderColor: "$neutral.40" }),
        footerLoading ? (React.createElement(Stack, { width: "100%", display: "flex", alignItems: "center" },
            React.createElement(LoadingSpinner, null))) : (React.createElement(Link, { testID: "PartnerConnection.stopSharing-btn", onPress: onStopSharing, textColor: "$support.danger.default" }, i18n.t('ConnectedRedoxPartner.content.connectedRedoxPartnerTile.links.stopSharing.label')))));
};
export default Redox;
